<template>
  <div class="bigBox">
    <div class="workcenter">
      <Card dis-hover class="sum-card-box2">
        <div class="center-0">
          <div class="center-01">
            <h3>故障类型</h3>
            <div @click="tiaozhaun(1)">
              <Icon type="md-add" size="20" />
            </div>
          </div>
          <div class="center-02">
            <div>
              <Input
                v-model="name"
                placeholder="请输入关键词"
                clearable
                @on-change="Search2(name)"
                icon="ios-search"
              />
            </div>
            <div class="center-03">
              <Table
                :columns="columns2"
                :data="data2"
                :stripe="false"
                highlight-row
                @on-row-click="rowClick2"
              ></Table>
            </div>
          </div>
        </div>
      </Card>
    </div>
    <div class="workcenter">
      <Card dis-hover class="sum-card-box2">
        <div class="center-0">
          <div class="center-01">
            <h3>故障常用语</h3>
            <div @click="tiaozhaun(2)">
              <Icon type="md-add" size="20" />
            </div>
          </div>
          <div class="center-02">
            <div>
              <Input
                v-model="descr"
                placeholder="请输入关键词"
                clearable
                @on-change="Search1(descr)"
                icon="ios-search"
              />
            </div>
            <div class="center-03">
              <Table
                :columns="columns"
                :data="data"
                stripe
                highlight-row
                @on-row-click="rowClick"
              ></Table>
            </div>
          </div>
        </div>
      </Card>
    </div>
    <div class="workleft">
      <Card
        class="sum-card-box"
        dis-hover
        :padding="0"
        style="background: #fff"
      >
        <h3>创建工单</h3>
        <div class="first-line">
          <div>
            <p><span style="color: red">*</span> 科室:</p>
            <el-select
                v-model="DepartmentValue"
                class="Select"
                filterable
                remote
                reserve-keyword
                placeholder="请选择或搜索科室"
                :remote-method="remoteMethod1"
                @change="OnDepartment(DepartmentValue)"
                :loading="loading1">
              <el-option
                  v-for="item in deskList"
                  :key="item.id"
                  :label="item.deskName"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div>
            <p>设备信息:</p>
            <el-select class="Select" v-model="EquipmentValue" filterable remote reserve-keyword
                       :remote-method="remoteMethod2" placeholder="请选择或搜索设备信息" clearable="true" :loading="loading2"
                       @change="SelectEquipment(EquipmentValue)">
              <el-option v-for="item in EquipmentList" :value="item.Num" :key="item.id" :label="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="first-line">
          <div>
            <p style="display: inline">科室信息:</p>
            <Input
              class="Select"
              v-model="RepairText"
              placeholder="请选择科室"
              disabled
            ></Input>
          </div>
          <div>
            <p><span style="color: red">*</span>故障类型:</p>
            <Input
              class="Select"
              v-model="FaultTypeText"
              :placeholder="guzhang"
              disabled
            ></Input>
          </div>
        </div>
        <div class="workleft-0">
          <p>故障描述:</p>
          <div class="left-01">
            <Input
              v-model="getText"
              type="textarea"
              :autosize="{ minRows: 10, maxRows: 10 }"
              placeholder="请输入或点击左侧选择"
            ></Input>
          </div>
        </div>
        <div class="workleft-1">
          <!--          <div class="left-11">-->
          <!--            <p>派单类型:</p>-->
          <!--            <Checkbox v-model="single" @on-change="changeOrderType">自动-->
          <!--            </Checkbox>-->
          <!--          </div>-->
          <div class="workleft-11">
            <p>派单类型:</p>
            <!--  <Select
              class="left-13-Select"
              v-model="sendType"
              placeholder="请选择派单类型"
              clearable="true"
              @on-change="changeOrderType(sendType)"
            >
              <Option
                v-for="item in OrderTypeList"
                :value="item.num"
                :key="item.value"
                >{{ item.value }}
              </Option>
            </Select> -->
            <RadioGroup v-model="border">
              <Radio label="手动派单" border></Radio>
              <Radio label="自动派单" border></Radio>
              <Radio label="抢单派单" border></Radio>
            </RadioGroup>
          </div>

          <div class="workleft-12">
            <p v-show="single == false ? true : false">
              <span style="color: red">*</span> 指定维修员:
            </p>
            <Select
              class="left-12-Select"
              v-model="engineer"
              placeholder="请选择维修员"
              clearable="true"
              @on-change="Selectengineer2(engineer)"
              v-show="single == false ? true : false"
            >
              <Option
                v-for="item in engineerList2"
                :value="item.name"
                :key="item.id"
                >{{ item.name }}
              </Option>
            </Select>
          </div>
        </div>
        <div class="workleft-2">
          <div class="left-21"></div>
          <Button type="info" @click="newWork" size="default" class="button2"
            >保存
          </Button>
        </div>
      </Card>
    </div>
  </div>
</template>
<script>
import Change from "../../workOrder/question";
import siblingCall from "@/utils/siblingCall";

export default {
  name: "simple",
  components: {
    change: Change,
  },

  data() {
    return {
      border: '手动派单',
      RepairText: "",
      single: true,
      DepartmentValue: "", //科室信息
      EquipmentValue: "", //设备信息
      value: "",
      workTypes2: [],
      workTypesTwo: [],
      selectModel: null,
      selectModelTwo: null,
      textarea1: "",
      deskList: [], //科室列表
      EquipmentList: {}, //设备列表
      FaultTypeText: "", //故障类型
      guzhang: "请点击左侧选择",
      OrderType: "", //派单类型
      OrderTypeList: [
        { value: "自动派单", num: 1 },
        { value: "手动派单", num: 2 },
        { value: "抢单派单", num: 3 },
      ],
      engineer: "",
      engineerList2: [], //维修员列表
      descr: "",
      data: [],
      data2: [],
      allData: [],
      allData2: [],
      workType: 1,
      name: "",
      columns: [
        {
          title: "问题描述",
          minWidth: 170,
          align: "left",
          key: "descr",
        },
      ],
      columns2: [
        {
          title: "故障类型",
          minWidth: 170,
          align: "left",
          key: "name",
          ellipsis: "true",
        },
      ],
      getText: "", //故障描述
      deskId: "", //科室id
      facilityNo: "", //设备编号
      Keydepartment: "", //重点科室
      typeId: "", //工单类型ID
      sendType: 2, //派单类型
      state: "", //状态
      maintainerId: "", //维修员ID
      loading1: false,
      loading2: false,
    };
  },
  computed: {
    extRender() {
      return ["change"];
    },
  },
  async created() {
    await this.loadfaultData();
    await this.workTypeMethod();
    await this.deskListMethod();
    await this.loadData();
  },
  methods: {
    async remoteMethod1(query) {
      let d = {}
      this.loading1 = true
      if (query !== "") {
        d.deskName = query
      }
      console.log(query)
      let res = await $utils.api.load("/admin/system/desk/selectList", d, "get");
      if (res && res.rows) {

        this.loading1 = false
        this.deskList = res.rows;
        console.log(this.deskList)
      } else {
        this.loading1 = false
      }
    },
    async remoteMethod2(query) {
      let d = {}
      this.loading2 = true
      if (query !== "") {
        d.facilityName = query
      }
      let res = await $utils.api.load("/admin/system/facility/selectListSearch", d, "get");
      if (res && res.rows) {

        this.loading2 = false
        let list = res.rows;
        let arr = []
        if (list.length > 0) {
          for (let i = 0; i < list.length; i++) {
            let item = list[i];
            let obj = {};
            obj.deskId = item.deskId;
            obj.value = item.assetNum + "_" + item.facilityName + "_" + item.facilityType;
            obj.Num = item.facilityNum;
            arr.push(obj);
          }
        }
        this.EquipmentList = arr;

      } else {
        this.loading2 = false
      }
    },
    //常用语跳转
    tiaozhaun(item) {
      console.log(item);
      if (item == 1) {
        $utils.url.push({
          name: "worktype_list",
        });
      } else if (item == 2) {
        $utils.url.push({
          name: "commondescr_list",
        });
      }
    },
    //派单类型
    changeOrderType(item) {
      console.log(item);
      if (item == 2) {
        this.single = false;
      } else {
        this.single = true;
      }
    },
    //重点科室
    department(status) {
      if (status == true) {
        this.Keydepartment = 1;
      } else {
        this.Keydepartment = 2;
      }
    },
    //选择维修员
    Selectengineer2(item) {
      if (this.engineerList2.length > 0) {
        for (let i = 0; i < this.engineerList2.length; i++) {
          let a = this.engineerList2[i];
          if (a.name == item) {
            this.maintainerId = a.id;
          }
        }
      }
    },
    //选择设备
    SelectEquipment(item) {
      let list = this.EquipmentList;
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          let a = list[i];
          if (a.value == item) {
            this.loadfaultData(a.Num);
            this.DepartmentValue = a.deskId
            this.Department(this.DepartmentValue);
            this.facilityNo = a.Num;
          }
        }
      } else {
        this.data2 = [];
      }
    },
    //选择故障类型
    async loadfaultData(facilityNo) {
      let q = {};
      q.facilityNum = facilityNo;
      let res = await $utils.api.load(`/admin/system/facility/workTypeHome`, q);
      if (res && res.rows) {
        let list = res.rows;
        if (list.length === 0) {
          this.guzhang = "该设备暂无故障类型";
          this.allData2 = [];
          this.data2 = [];
          this.FaultTypeText = "";
        } else {
          this.guzhang = "请点击左侧选择";
          let lists = [];
          list.forEach((obj) => {
            lists.push({ name: obj.name, id: obj.id });
            if (obj.deskList && obj.deskList.length > 0) {
              obj.deskList.forEach((item) => {
                const newObj = {
                  name: `${obj.name}-${item.name}`,
                  id: item.id,
                };
                lists.push(newObj);

              });
            }
          });
          this.allData2 = lists;
          this.data2 = lists;
        }
      }
    },
    //查询维修员
    loaduserData(typeParentId) {
      let typeId = typeParentId;
      // 通过pk查询字典数据
      $utils.api.load(`/admin/system/maiUser/type/${typeId}`).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let arr = [];
          if (ll.length > 0) {
            for (let i = 0; i < ll.length; i++) {
              let item = ll[i];
              let obj = {
                name: item.nickName,
                id: item.userId,
              };
              arr.push(obj);
            }
            this.engineerList2 = arr;
          }
        }
      });
    },
    //数组去重
    removeDuplicate(arr) {
      let len = arr.length;
      for (let i = 0; i < len; i++) {
        for (let j = i + 1; j < len; j++) {
          if (arr[i] === arr[j]) {
            arr.splice(j, 1);
            len--; // 减少循环次数提高性能
            j--; // 保证j的值自加后不变
          }
        }
      }
      return arr;
    },
    async rowClick2(row) {
      // 点击选择行
      this.FaultTypeText = row.name;
      this.typeId = row.id;
      console.log(row);
      this.loaduserData(row.id); //查询维修员
      await this.loadData(row.id)
    },
    Search2(descr) {
      let keyword = this.name;
      let allData = this.allData2;
      let newData = [];
      for (let index = 0; index < allData.length; index++) {
        let item = allData[index] || {};
        let descrOld = item.name;
        if (descrOld.indexOf(keyword) != -1) {
          newData.push(item);
          this.data2 = newData;
        }
      }
    },
    Search1(descr) {
      let keyword = this.descr;
      let allData = this.allData;
      let newData = [];
      for (let index = 0; index < allData.length; index++) {
        let item = allData[index] || {};
        let descrOld = item.descr;
        if (descrOld.indexOf(keyword) != -1) {
          newData.push(item);
          this.data = newData;
        }
      }
    },
    rowClick(row) {
      // 点击选择行
      let descr = row.descr;
      console.log(descr);
      if (this.getText == "" || descr != this.getText) {
        this.getText = this.getText + "," + descr;
      }
    },
    async loadData(id) {
      let q = {};
      q.workTypeId = id;
      let res = await $utils.api.load("/admin/system/common/pageList", q);
      if (res) {
        if (res.code > 0) {
          let list = res.rows || [];
          this.allData = list;
          this.data = list;
        }
      }
    },
    clickRow(data) {
      this.textarea1 = this.textarea1 + data;
    },
    async workTypeMethod() {
      let q = {};
      let res = await $utils.api.load("/admin/system/workType/list", q);
      this.workTypes2 = res.rows;
    },
    async workTypeTwoMethod(value) {
      if (value) {
        let res = await $utils.api.load(
          "/admin/system/workType/parentId/" + parseInt(value)
        );
        this.workTypesTwo = res.data;
      } else {
        this.selectModelTwo = null;
        this.workTypesTwo = [];
      }
    },
    async deskListMethod() {
      let res = await $utils.api.load("/admin/system/desk/selectList");
      this.deskList = res.rows;
    },
    async usefulPxpressions() {
      this.$refs.tanchuang.loadData(1);
      this.$refs.tanchuang.open();
    },
    async OnDepartment(deskId) {
      this.deskId = deskId;
      await this.Department(deskId);
      let q = {};
      q.state = 2;
      q.deskId = deskId;
      let res = await $utils.api.load(
        "/admin/system/facility/selectListSearch",
        q,
        "get"
      );
      let list = res.rows;
      let arr = [];
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          let obj = {};
          obj.deskId = item.deskId
          obj.value =
            item.assetNum + "_" + item.facilityName + "_" + item.facilityType
            obj.Num = item.facilityNum
            arr.push(obj);
        }
      } else {
        this.EquipmentValue = "";
        this.FaultTypeText = "";
      }
      this.EquipmentList = arr;
    },
    async Department(id) {
      if (id == undefined) {
        return;
      } else {
        let res = await $utils.api.load(`/admin/system/desk/${id}`);
        if (res.code === 200) {
          let workInfotemp = "";
          if (res.data.principal !== null && res.data.principal !== undefined) {
            workInfotemp = res.data.principal ;
          }
          if (res.data.phone !== null && res.data.phone !== undefined) {
            workInfotemp = workInfotemp +  "/" + res.data.phone;
          }
          if (res.data.address !== null && res.data.address !== "") {
            workInfotemp =
              workInfotemp +
                "/" +
                res.data.address;
          }
          this.RepairText = workInfotemp;
        }
      }
    },
    //提交工单
    // 科室id(deskId)   设备编号(facilityNo)  重点科室(1,2)  故障类型有二级给二级id,没有给一级(typeId)
    // 故障描述(descr)  派单类型(sendType  自动传1,手动传2)  状态(state=1)  维修员ID(maintainerId)
    async newWork() {
      let q = {};
      q.deskId = this.deskId;
      if (this.typeId == "") {
        return $utils.toast.error("故障类型不可为空");
      }
      if (this.getText == "") {
        return $utils.toast.error("故障描述不可为空");
      }
      if (!this.single && !this.engineer) {
        return $utils.toast.error("手动派单维修员不可为空");
      }
      q.descr = this.getText;
      q.typeId = this.typeId;
      if (this.facilityNo == "") {
        q.isFastOrder = 1;
      } else {
        q.isFastOrder = 0;
        q.facilityNo = this.facilityNo;
      }
      q.repairSource = 3
      q.sendType = this.sendType;
      q.state = 1;
      q.maintainerId = this.maintainerId;
      q.maintainType = 2;
      console.log(q);
      let res = await $utils.api.load("/admin/system/work/flashAdd", q, "post");
      if (res.code == 200) {
        await $utils.toast.success("保存成功");
        this.$emit("complete");
        this.rest();
        siblingCall.$emit("event");
      } else {
        $utils.toast.error("保存失败");
      }
    },
    diaoyong() {
      siblingCall.$emit("event");
    },
    rest() {
      this.RepairText = "";
      this.DepartmentValue = "";
      this.EquipmentValue = "";
      this.FaultTypeText = "";
      this.getText = "";
      this.OrderType = "";
      this.engineer = "";
    },
  },
};
</script>
<style lang="less" scoped>
.bigBox {
  height: 600px;
  margin-top: 17px;
  display: flex;
  justify-content: space-between;

  .workleft {
    width: 51%;
    height: 100%;
    .first-line {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      margin-top: 10px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 50%;

        .Select {
          width: 75%;
          display: inline-block;
        }

        p {
          font-size: 0.75rem;
          padding-top: 5px;
          text-align: left;
          width: 21%;
          min-width: 20%;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }

    .workleft-0 {
      font-size: 12px;
      margin-top: 10px;

      p {
        width: 11%;
        display: inline-block;
      }

      .left-01 {
        display: inline-block;
        width: 88%;
        vertical-align: top;
      }
    }

    .workleft-1 {
      height: 33px;
      margin-top: 10px;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      margin-bottom: 10px;

      .workleft-11 {
        font-size: 12px;
        width: 50%;
        padding-top: 2px;
        padding-left: 5px;

        .left-13-Select {
          width: 50%;
          margin-bottom: 0px;

          display: inline-block;
        }
        p {
          width: 20%;
          display: inline-block;
        }
      }

      .workleft-12 {
        width: 50%;

        p {
          width: 40%;
          display: inline-block;
        }

        .left-12-Select {
          width: 60%;
          display: inline-block;
        }
      }
    }

    .workleft-2 {
      .left-21 {
        width: 11%;
        display: inline-block;
      }
    }
  }
  .workcenter {
    // width: 13%;
    .center-02 {
      height: 390px;

      .center-03 {
        height: 130%;
        overflow: auto;
      }
    }
    i {
      cursor: pointer;
    }
    .center-01 {
      width: 100%;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }
  }
}

.sum-card-box {
  width: 100%;
  height: 100%;
  padding: 16px;
}

.sum-card-box2 {
  padding: 0;
  width: 100%;
  height: 100%;
}
/deep/ .ivu-input[disabled] {
  background-color: #f3f3f3;
  opacity: 1;
  cursor: not-allowed;
  color: #f00;
}
/deep/ .ivu-input {
  display: inline-block;
  width: 100%;
  height: 32px;
  line-height: 1.5;
  padding: 4px 7px;
  font-size: 14px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  color: #3871f1;
  background-color: #fff;
  background-image: none;
  position: relative;
  cursor: text;
  transition: border 0.2s ease-in-out, background 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}
</style>
